<div class="info-message-box-panel">
  <span class="info-icon"><svg-icon key="info-full"></svg-icon></span>
  <span class="info-message" [innerHTML]="message"></span>
</div>
